
import { Data } from './data';

export class Menu extends Data {

    
    nom : string;

    constructor() {
        super();
    }


}
